import React from 'react';
import moment from 'moment';
import { DATE_TIME_FORMAT } from '../../../constants';
import FormError from 'components/FormError';
import DiagnosticActions from './DiagnosticActions';

const DiagnosticData = ({
  simoDeviceId,
  diagnostic,
  actionsError,
  restartConnection,
  sendSignalScan,
  restartDevice,
}) => {
  const {
    device_sn,
    equipment_power,
    charging,
    device_type_name,
    device_version,
    imei,
    simo_imei,
    last_known_vsim_imsi,
    last_known_vsim_carrier,
    last_known_vsim_network,
    last_known_vsim_cell_id,
    last_known_vsim_signal_strength,
    last_known_vsim_lac,
    last_known_connection_start,
    last_known_connection_end,
    last_known_connection_duration,
    wifi_ssid,
    wifi_password,
  } = diagnostic || {};

  const formatValue = (value) => {
    if (value === '' || value === null) {
      return '--';
    }

    return value;
  };

  const data = [
    {
      topic: 'Device Status',
      content: [
        [
          { label: 'Device SN', value: device_sn },
          {
            label: 'Equipment power',
            value: equipment_power ? `${equipment_power}%` : '0%',
            icon: charging
              ? '/images/icons/diagonistic-data/charge-icon.svg'
              : '',
          },
          { label: 'Device Type', value: device_type_name },
        ],
        [
          { label: 'Device Version', value: device_version },
          { label: 'IMEI', value: imei },
          { label: 'SIMO IMEI', value: simo_imei },
        ],
      ],
    },
    {
      topic: 'Last Known Connection Status',
      content: [
        [
          { label: 'VSIM IMSI', value: last_known_vsim_imsi },
          { label: 'VSIM Carrier', value: last_known_vsim_carrier },
          { label: 'VSIM Network', value: last_known_vsim_network },
        ],
        [
          { label: 'VSIM Cell Id', value: last_known_vsim_cell_id },
          {
            label: 'VSIM Signal',
            value: last_known_vsim_signal_strength
              ? last_known_vsim_signal_strength
              : '0',
          },
          { label: 'VSIM Lac', value: last_known_vsim_lac },
        ],
        [
          {
            label: 'Connection start',
            value: last_known_connection_start
              ? moment(last_known_connection_start).format(DATE_TIME_FORMAT)
              : null,
          },
          {
            label: 'Connection end',
            value: last_known_connection_end
              ? moment(last_known_connection_end).format(DATE_TIME_FORMAT)
              : null,
          },
          {
            label: 'Connection duration',
            value: last_known_connection_duration,
          },
        ],
      ],
    },
    {
      topic: 'WiFi Hotspot',
      content: [
        [
          { label: 'WiFi Name', value: wifi_ssid },
          { label: 'WiFi Password', value: wifi_password },
        ],
      ],
    },
  ];

  return (
    <div className="simo-diagnostic">
      {data.map(({ topic, content }) => (
        <React.Fragment key={topic}>
          <div className="simo-diagnostic-topic">{topic}</div>
          <div className="simo-diagnostic-data">
            {content.map((row, i) => (
              <div key={i} className="simo-diagnostic-row">
                {row.map(({ label, value, icon }) => (
                  <React.Fragment key={label}>
                    <div className="simo-diagnostic-header">{label}</div>
                    <div className="simo-diagnostic-value">
                      {formatValue(value)}
                      {icon && (
                        <img
                          style={{
                            marginLeft: '10px',
                            width: '24px',
                            height: 'auto',
                          }}
                          src={icon}
                          alt=""
                        />
                      )}
                    </div>
                  </React.Fragment>
                ))}
              </div>
            ))}
          </div>
        </React.Fragment>
      ))}
      <div className="simo-diagnostic-topic">Remote Actions</div>
      <div className="simo-diagnostic-data">
        <DiagnosticActions
          simoDeviceId={simoDeviceId}
          diagnostic={diagnostic}
          restartConnection={restartConnection}
          sendSignalScan={sendSignalScan}
          restartDevice={restartDevice}
        />
        <div className="simo-diagnostic-error">
          {actionsError && <FormError error={actionsError} />}
        </div>
      </div>
    </div>
  );
};

export default DiagnosticData;
